/** Roles del sistema GFI Latino (sincronizado con enum gfi_user_role en Supabase) */
export const GFI_ROLES = {
  member: { label: 'Miembro', level: 1 },
  instructor: { label: 'Instructor', level: 2 },
  ambassador: { label: 'Embajador', level: 3 },
  counsel: { label: 'Counsel', level: 4 },
  admin: { label: 'Admin', level: 5 },
  superadmin: { label: 'Superadmin', level: 6 },
};

export const GFI_ROLE_OPTIONS = Object.entries(GFI_ROLES).map(([value, { label }]) => ({
  value,
  label,
}));

/** Permisos por capacidad — la validación real vive en RLS/RPC de Supabase */
export const PERMISSIONS = {
  upload_training: ['instructor', 'ambassador', 'admin', 'superadmin'],
  manage_training_paths: ['admin', 'superadmin'],
  suggest_training_path: ['instructor', 'ambassador', 'admin', 'superadmin'],
  upload_resources: ['instructor', 'ambassador', 'admin', 'superadmin'],
  moderate_training_comments: ['instructor', 'admin', 'superadmin'],
  blog_draft: ['instructor', 'ambassador', 'admin', 'superadmin'],
  blog_publish: ['superadmin'],
  manage_roadmap: ['ambassador', 'counsel', 'admin', 'superadmin'],
  curate_faq: ['counsel', 'admin', 'superadmin'],
  moderate_content: ['admin', 'superadmin'],
  upload_tevah_csv: ['admin', 'superadmin'],
  manage_users: ['superadmin'],
  view_agent_conflicts: ['admin', 'superadmin'],
  claim_live_session: ['instructor', 'ambassador', 'counsel', 'admin', 'superadmin'],
  manage_live_sessions: ['admin', 'superadmin'],
};

export function getRoleLabel(role) {
  return GFI_ROLES[role]?.label ?? role;
}

export function hasPermission(role, permission) {
  if (!role) return false;
  const allowed = PERMISSIONS[permission];
  return Array.isArray(allowed) && allowed.includes(role);
}

export function canManageRoadmap(role) {
  return hasPermission(role, 'manage_roadmap');
}

export function canCurateFaq(role) {
  return hasPermission(role, 'curate_faq');
}

export function canManageUsers(role) {
  return hasPermission(role, 'manage_users');
}

export function canViewAgentConflicts(role) {
  return hasPermission(role, 'view_agent_conflicts');
}
